// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3Es1a","content":"styles_content__Zskmc","checkbox":"styles_checkbox__DDxKV","checkboxLabel":"styles_checkboxLabel__PdCun"};